<template>
  <div>
    <!-- toasts message -->
    <v-card color="grey lighten-4">
      <Snackbar :SnackbarVal="SnackbarVal" ref="loader"></Snackbar>
    </v-card>
    <!-- /toasts message -->

    <!-- Confirmation delete box -->
    <v-layout row justify-center>
      <v-dialog v-model="dialog2" max-width="290">
        <v-card>
          <v-card-text>Are you sure you want to delete this data?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="green darken-1" flat="flat" @click.native="dialog2 = false">Disagree</v-btn>
            <v-btn
              color="green darken-1"
              flat="flat"
              @click.native="confirmDelete(row_index, delete_id)"
            >Agree</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <!-- /Confirmation delete box -->

    <v-form v-model="valid" ref="form" lazy-validation>
      <v-card-text>
        <v-container grid-list-md>
          <v-layout wrap>
            <!-- <v-flex xs12 sm6 md6>
              <v-autocomplete
                label="PFI Short Name"
                item-text="short_name"
                item-value="id"
                v-model="formSchema.pfi_info_id"
                :items="PFIinformationList"
                :rules="[v => !!v || 'PFI short name is required !']"
                required
                clearable
              ></v-autocomplete>
            </v-flex> -->

            <input type="hidden" v-model="formSchema.pfi_info_id" value="formSchema.pfi_info_id">

            <v-flex xs12 sm6 md6>
              <div style="
              border-bottom:1px solid #CCC;
              margin-top: -19px;
              line-height: 33px;
              color:rgba(0,0,0,0.54);
              ">
              <div>PFI Short Name</div>
              <div style="color:#000">{{pfi_short_name}}</div>
              </div>
              <!-- <v-text-field
                label="PFI Short Name"
                v-model="pfi_short_name"
                :rules="[v => !!v || 'PFI short name is required !']"
                required
                readonly
              ></v-text-field> -->
            </v-flex>

            <!-- <v-flex xs12 sm6 md6>
              <v-text-field
                label="Contract Person Code"
                v-model="formSchema.contract_person_code"
                :rules="[v => !!v || 'Contract person code is required !',decimal,lng11]"
                required
              ></v-text-field>
            </v-flex> -->

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Name *"
                v-model="formSchema.name"
                :rules="[v => !!v || 'Name is required !',lng50]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Mobile No *"
                v-model="formSchema.mobile"
                :rules="[rules.phoneNumber]"
                required
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Designation" v-model="formSchema.designation"></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field label="Email ID" v-model="formSchema.email" :rules="[email]"></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>

    </v-form>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" @click="previous">
        <v-icon>arrow_back_ios</v-icon>Previous
      </v-btn>
      <v-btn color="success" @click.once="checkFormValidation">
        <v-icon>save</v-icon>
        {{addUpdateBtn}}
      </v-btn>
      <v-btn color="error" @click="reset">
        Reset
        <v-icon>refresh</v-icon>
      </v-btn>      
    </v-card-actions>

    <v-card-title>
      <h2>Contact Person</h2>
      <v-spacer></v-spacer>
      <v-text-field append-icon="search" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>

    <span style="display:none;">{{serial=serialNumber}}</span>
    <v-data-table
      :headers="headers"
      :items="desserts"
      :pagination.sync="pagination"
      :total-items="totalDesserts"
      :loading="loading"
      class="elevation-4"
    >
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{serial++}}</td>
        <td class="text-xs-left">{{ props.item.short_name }}</td>
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.mobile }}</td>
        <td class="text-xs-left">{{ props.item.designation }}</td>
        <td class="text-xs-left">{{ props.item.email }}</td>
        <td class="justify-center layout px-0">
          <v-btn icon class="mx-0" @click="editItem(props.index, props.item)">
            <v-icon color="teal">edit</v-icon>
          </v-btn>
          <v-btn icon class="mx-0" @click="deleteItem(props.index, props.item.id)">
            <v-icon color="pink">delete</v-icon>
          </v-btn>
        </td>
      </template>
    </v-data-table>
  </div>
</template>

<script>
let commonService = require("../../../../services/common.service");
export default {
  data() {
    return {
      valid: true,
      e1: 0,
      PFIinformationList: [],

      pfi_info_id:'',
      pfi_short_name:'',

      delete_id: "",
      row_index: "",
      dialog2: false,

      SnackbarVal: {
        snackbar: false,
        color: "success",
        message: ""
      },

      formSchema: {
        id: 0,
        name: "",
        mobile: "",
        designation: "",
        email: "",
        contract_person_code:"",
      },

      /*------------- Datatable ---------------*/
      serialNumber: 0,
      sort: "",
      queryData: {
        sortBy: "id",
        descending: true,
        page: 1,
        rowsPerPage: 5,
        totalItems: 0,
        search_val: ""
      },

      search: "",
      totalDesserts: 0,
      desserts: [],
      loading: true,
      pagination: {},

      headers: [
        {
          text: "SL",
          value: ""
        },
        {
          text: "Info Short Name",
          align: "left",
          sortable: true,
          value: "short_name"
        },
        {
          text: "Name",
          align: "left",
          sortable: true,
          value: "name"
        },
        {
          text: "Mobile No",
          align: "left",
          sortable: true,
          value: "mobile"
        },
        {
          text: "Designation",
          align: "left",
          sortable: true,
          value: "designation"
        },
        {
          text: "Email ID",
          align: "left",
          sortable: true,
          value: "email"
        },

        { text: "Action", align: "center", value: "" }
      ],
      /*------------- /Datatable ---------------*/

        rules: {
        phoneNumber: (v) => {
          // const pattern = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{5})$/;
          // return pattern.test(value) || "Enter valid phone no.";
          if (v && v.length > 0) {
            return (
              /(\+)?^[+0-9\(\)_.-]*$/.test(v) ||
              "Phone no. must be valid"
            );
          } else {
            return true;
          }
        },
      },
      
    };
  },

  created() {

    /*let PfiShortName = sessionStorage.getItem("PfiShortName")  
    commonService.getAllData("drodown-data-for-pifContact").then(res => {
      this.PFIinformationList = res;
    });*/

    let PfiShortName = sessionStorage.getItem("PfiShortName") 
    commonService.getAllDataById(PfiShortName, "pfi-information").then(res => {
      this.PFIinformationList = res.data;
      this.pfi_short_name = res.data.length>0 ? res.data[0].short_name: '';
      this.pfi_info_id = this.formSchema.pfi_info_id = (PfiShortName>0) ? parseInt(PfiShortName) : '';
    });

  },

  /*------------Datatable------------*/
  watch: {
    params: {
      handler() {
        this.getDataFromApi().then(data => {
          this.desserts = data.items;
          this.totalDesserts = data.total;
        });
      },
      deep: true
    }
  },

  computed: {
    params(nv) {
      return {
        ...this.pagination,
        query: this.search
      };
    },
    addUpdateBtn() {
      return this.formSchema.id > 0 ? "Update" : "Save";
    }
  },
  /*------------/Datatable------------*/

  methods: {
    getDataFromApi() {
      this.loading = true;
      return new Promise((resolve, reject) => {
        const { sortBy, descending, page, rowsPerPage } = this.pagination;
        let search = this.search.trim().toLowerCase();
        let PfiShortName = sessionStorage.getItem("PfiShortName")
        let query_Data = this.queryData;

        (query_Data.sortBy = "id"),
          (query_Data.descending = this.pagination.descending),
          (query_Data.page = this.pagination.page),
          (query_Data.rowsPerPage = this.pagination.rowsPerPage),
          (query_Data.PfiShortName = PfiShortName),
          (query_Data.search_val = this.search);

        const serialNumber =
          this.pagination.rowsPerPage * this.pagination.page -
          this.pagination.rowsPerPage;
        this.serialNumber = serialNumber + 1;

        commonService
          .getServerSideData(query_Data, "pfi-contact-person-list")
          .then(res => {
            let items = res.data;
            const total = res.totalRecords;

            if (search) {
              items = items.filter(item => {
                return Object.values(item)
                  .join(",")
                  .toLowerCase()
                  .includes(search);
              });
            }

            if (this.pagination.sortBy) {
              items = items.sort((a, b) => {
                const sortA = a[sortBy];
                const sortB = b[sortBy];

                if (descending) {
                  if (sortA < sortB) return 1;
                  if (sortA > sortB) return -1;
                  return 0;
                } else {
                  if (sortA < sortB) return -1;
                  if (sortA > sortB) return 1;
                  return 0;
                }
              });
            }

            setTimeout(() => {
              this.loading = false;
              resolve({
                items,
                total
              });
            }, 300);
          });
      });
    },

    checkFormValidation() {
      if (this.$refs.form.validate()) {
        this.submitForm();
      }
    },

    submitForm() {
      this.$refs.loader.loaderEnabled();

      let $this = this;
      let formSchema = $this.formSchema;

      //commonService.insertFormData(formSchema, "pfi-contact-person")

      let saveUpdate = 'insertFormData';
      if(formSchema.id>0)
      {
        saveUpdate = 'updateFormData';
      }

      commonService[saveUpdate](formSchema, "pfi-contact-person")
        .then(res => {

          if (res.status == 1) {
            if (res.action == "update") {
              this.$set(this.desserts, this.row_index, { ...res.data });
            } else {
              $this.desserts.unshift({ ...res.data });
            }
            $this.SnackbarVal.message = res.message;
            $this.SnackbarVal.snackbar = true;
            $this.SnackbarVal.color = "success";
            $this.close();

            window.scrollTo({
              left: 0,
              top:
                document.body.scrollHeight ||
                document.documentElement.scrollHeight,
              behavior: "smooth"
            });

            setTimeout(function() {
              $this.nextStep();
            }, 3000);
          }
        });
    },

    nextStep() {
      this.$emit("emitForm1", 2);
    },

    previous() {
      this.$emit("emitForm2", 1);
    },

    editItem(index, item) {
      console.log("index", index);
      console.log("item", item);

      this.row_index = index;
      this.formSchema = { ...item };
      window.scrollTo({
        top: 0,
        left: 100,
        behavior: "smooth"
      });
    },

    deleteItem(index, id) {
      this.row_index = index;
      this.delete_id = id;
      this.dialog2 = true;
    },

    confirmDelete(row_index, id) {
      commonService.deleteRow(id, "pfi-contact-person").then(res => {
        if (res.status == 1) {
          this.desserts.splice(row_index, 1);
        }
        this.message = res.message;
        this.snackbar = true;
        this.confirmModel = false;
        this.dialog2 = false;
      });
    },

    close: function() {
      this.$refs.form.reset();
      this.formSchema.id = 0;
      this.formSchema.pfi_info_id = this.pfi_info_id;
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/lending/PFI/step_forms/contactPerson.vue